module.exports = __webpack_public_path__ + "img/guonongshuangzi.bd50144d.jpg";